import {lazy} from 'react'

// ** Document title
const TemplateTitle = '%s - Law school'

// ** Default Route
const DefaultRoute = '/home'

// ** Merge Routes
const Routes = [
    {
        path: '/admin/home',
        component: lazy(() => import('../../views/admin/Statistics')),
        layout: 'VerticalLayout',
        meta: {
            action: 'manage',
            resource: 'admin'
        }

    },
    {
        path: '/home',
        component: lazy(() => import('../../views/pages/Home')),
        layout: 'BlankLayout',
        meta: {
            publicRoute: true
        }

    },
    {
        path: '/more-details/:typeCode',
        component: lazy(() => import('../../views/pages/MoreDetails')),
        layout: 'BlankLayout',
        meta: {
            publicRoute: true
        }

    },
    {
        path: '/test',
        component: lazy(() => import('../../views/pages/Test')),
        layout: 'BlankLayout',
        meta: {
            publicRoute: true
        }

    },
    {
        path: '/result/:typeCode',
        component: lazy(() => import('../../views/pages/Result')),
        layout: 'BlankLayout',
        meta: {
            publicRoute: true
        }

    },
    {
        path: '/personality-list',
        component: lazy(() => import('../../views/pages/PersonalityList')),
        layout: 'BlankLayout',
        meta: {
            publicRoute: true
        }

    },
    {
        path: '/personality-analysis',
        component: lazy(() => import('../../views/pages/AdvancedAnalysis')),
        layout: 'BlankLayout',
        meta: {
            publicRoute: true
        }

    },
    {
        path: '/contact-us',
        component: lazy(() => import('../../views/pages/ContactUs')),
        layout: 'BlankLayout',
        meta: {
            publicRoute: true
        }

    },
    {
        path: '/login',
        component: lazy(() => import('../../views/Login')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        }
    },
    {
        path: '/error',
        component: lazy(() => import('../../views/Error')),
        layout: 'BlankLayout',
        meta: {
            publicRoute: true
        }
    }
]

export {DefaultRoute, TemplateTitle, Routes}
